import React, { ReactNode } from "react";

import { Section } from "../Section";
import { SubNav } from "../SubNav";

type Props = {
  headerIcon: ReactNode;
  headerTitle: string;
  rightNode?: ReactNode;
  upperChildren?: ReactNode;
  links: Array<{ label: string; link: string }>;
  subNavLeftNode?: ReactNode;
  children: ReactNode;
  navigationAriaLabel?: string;
  titleVariant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
};

export const SubLevelLayout = ({
  headerIcon,
  headerTitle,
  rightNode,
  links,
  children,
  upperChildren,
  subNavLeftNode,
  navigationAriaLabel,
  titleVariant,
}: Props) => {
  return (
    <Section
      icon={headerIcon}
      title={headerTitle}
      titleVariant={titleVariant}
      rightNode={rightNode}
    >
      {upperChildren}
      <SubNav links={links} aria-label={navigationAriaLabel} leftNode={subNavLeftNode} />
      {children}
    </Section>
  );
};
